// import React from 'react';
import React, { useState, useEffect } from 'react';
import './App.css';
import VideoChat from './VideoChat';

import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import { AmplifySignOut, withAuthenticator } from '@aws-amplify/ui-react';

Amplify.configure(awsconfig);

const App = () => {

  const [currentUser,setcurrentUser] = useState('');

  useEffect(() => {
    // get Cognito User Info ...................
    Auth.currentSession()
    .then((data) => {
     // console.log("id token " + JSON.stringify(data["idToken"]["payload"]["email"]) );
     // this data has user details
   //  let temp = JSON.stringify(data["idToken"]["payload"]["email"] );
   //  let temp1 = temp.substr(0, temp.length-1);
   //  let temp2 = temp1.myString.substr(1);
   //  alert("temp1, temp2 " + temp1 + " " + temp2);
  //   setcurrentUser(temp2);
     setcurrentUser( JSON.stringify(data["idToken"]["payload"]["email"] )); 
     
   }).catch(err => console.log(err));
  
  // endof userinfo .....
  }, []); // endof useeffect

  return (

    <div className="app">
      <header>
        <h1>Webteria Video Chat</h1>
      </header>
      <main>
        <AmplifySignOut />
        <div align="center">
        <p>Current User {currentUser} </p>
        </div>
        <VideoChat currentUser = {currentUser} />
      </main>
      <footer>
        <p>
          Using {' '}
          <span role="img" aria-label="React">
            ⚛️
          </span>{' '}
          Twilio <a href="https://www.twilio.com/"> Video Services</a>
        </p>
      </footer>
    </div>
  );
};

export default withAuthenticator(App);
// export default App;
